import MenuIcon from "@mui/icons-material/Menu";
import React, { useState, useEffect } from "react";
import { StyledTab, navbarStyles } from "./Styles";
import logo from "../../assets/logo/AcrossLogo.png";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Tabs, AppBar, Toolbar, Drawer, IconButton } from "@mui/material";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabRoutes = [
    "/",
    "/products",
    "/about-us",
    "/career",
    "/blogs",
    "/become-partner",
    "/contact",
  ];

  const [value, setValue] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Sync tab with URL
  useEffect(() => {
    const currentPath = location.pathname;
    const tabIndex = tabRoutes.findIndex((route) => route === currentPath);
    if (tabIndex !== -1) {
      setValue(tabIndex);
    }
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(tabRoutes[newValue]);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <AppBar position="fixed" sx={navbarStyles.appBar}>
      <Toolbar sx={navbarStyles.toolbar}>
        <Box
          mt={2}
          onClick={() => navigate("/")}
          component="img"
          src={logo}
          alt="Logo"
          // sx={{ height: { xs: 40, sm: 50, md: 60 } }}
          sx={{ height: { xs: 40, sm: 50, md: 55 } }} // Reduced height here
        />

        <Box sx={navbarStyles.tabsContainer}>
          <Tabs
            value={value}
            onChange={handleChange}
            TabIndicatorProps={{ style: { display: "none" } }}
            sx={[navbarStyles.tabs, { px: 0.7 }]}
            // p={2}
          >
            {[
              "Home",
              "Products",
              "About Us",
              "Career",
              "Blogs",
              "Become a Partner",
              "Contact Us",
            ].map((label, index) => (
              <StyledTab key={index} label={label} active={value === index} />
            ))}
          </Tabs>
        </Box>

        <IconButton sx={navbarStyles.menuButton} onClick={handleDrawerToggle}>
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={navbarStyles.drawer}
      >
        <Box sx={navbarStyles.drawerContent}>
          <Box
            mt={2}
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              ...navbarStyles.logo,
              mb: { xs: 1, md: 0 },
              width: { xs: "100%", md: "auto" },
              cursor: "pointer",
            }}
          />
          <Box
            sx={{
              width: "100%",
              mb: { xs: 3, md: 0 },
              border: "0.7px solid #cfd8dc",
            }}
          />
          {[
            "Home",
            "Products",
            "About Us",
            "Career",
            "Blogs",
            "Become a Partner",
            "Contact Us",
          ].map((label, index) => (
            <StyledTab
              key={index}
              label={label}
              active={value === index}
              onClick={() => {
                navigate(tabRoutes[index]);
                setMobileOpen(false);
              }}
            />
          ))}
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
